import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class EFormsOrgService {
	private needSecondOrganization: boolean = false;

	setNeedSecondOrganization(data: boolean): void {
		this.needSecondOrganization = data;
	}

	getNeedSecondOrganization(): boolean {
		return this.needSecondOrganization;
	}
}